import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, Button as MuiButton } from "@mui/material";
const SPINNER_SIZES = {
    small: 16,
    medium: 20,
    large: 24,
};
export const Button = ({ children, startIcon, endIcon, loading = false, loadingIcon, loadingPosition = "center", disabled = false, size = "medium", ...props }) => {
    const defaultLoadingIcon = (_jsx(CircularProgress, { color: "inherit", size: SPINNER_SIZES[size] }));
    const loadingElement = loadingIcon || defaultLoadingIcon;
    const buttonChildren = loading && loadingPosition === "center" ? loadingElement : children;
    return (_jsx(MuiButton, { disabled: disabled || loading, startIcon: loading && loadingPosition === "start" ? loadingElement : startIcon, endIcon: loading && loadingPosition === "end" ? loadingElement : endIcon, size: size, ...props, children: buttonChildren }));
};
//# sourceMappingURL=Button.js.map